import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable, of, fromEvent } from 'rxjs';
import {
  getFullRut,
  getLocalStorage,
  setLocalStorage,
} from 'src/app/shared/helpers/helper';
import { environment } from 'src/environments/environment';
import {
  IInformacionFTP,
  IInformationFTP,
  IScreenDim,
  InformationFTPBody,
} from '../Entities/entities';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  startWith,
  map,
  distinctUntilChanged,
  shareReplay,
  catchError,
} from 'rxjs/operators';
import {
  screenSizes,
  key_user_info,
  key_local_linea_nego,
  statusEnum,
} from '../helpers/constants';
import { DialogMessageModalComponent } from '../components/dialog-message-modal/dialog-message-modal.component';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  /* vidaUrl = 'https://api.vidasecurity.cl/vs/'; */

  private headers: HttpHeaders;
  apiBff = `${environment.url.apiBff}`;

  private _screenSize$: Observable<string>;

  private _screenDim$: Observable<IScreenDim>;

  constructor(
    private http: HttpClient,
    breakpointObserver: BreakpointObserver,
    public dialog: MatDialog
  ) {
    this._screenDim$ = fromEvent(window, 'resize').pipe(
      startWith(this._getScreenDim()),
      map((event: Event) => {
        return this._getScreenDim();
      }),
      distinctUntilChanged(),
      shareReplay(1)
    );

    this._screenSize$ = fromEvent(window, 'resize').pipe(
      startWith(this._getScreenSize()),
      map((event: Event) => {
        return this._getScreenSize();
      }),
      distinctUntilChanged(),
      shareReplay(1)
    );
  }

  /**
   * Realiza una solicitud POST para descargar un archivo a través de FTP.
   *
   * @param infoFTP - La información necesaria para la descarga FTP.
   * @returns Un observable que emite los datos de la descarga en formato base64.
   */
  postDownloadtFTP(infoFTP: IInformacionFTP): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);
    const token = getLocalStorage('token');

    const informationFtp: IInformationFTP = {
      data: {
        user: getFullRut(getLocalStorage(key_user_info).rut),
        connection: infoFTP.InformacionFTP.conexion,
        path: infoFTP.InformacionFTP.path,
        file: infoFTP.InformacionFTP.archivo,
      },
    };

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return this.http
      .post<any>(
        `${this.apiBff}/BffSitioPrivado/DownloadFTP/${getFullRut(
          userInfo.rut
        )}`,
        informationFtp,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'HA OCURRIDO UN PROBLEMA',
              message: 'Favor inténtelo más tarde.',
              type: statusEnum.error,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
          console.error('Error al obtener los datos:', err.message);
          return of([]);
        }),
        map(data => {
          return data.base64;
        })
      );
  }

  postDownloadtFTPFake(infoFTP: IInformacionFTP): Observable<any> {
    const token = getLocalStorage('token');

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    infoFTP.InformacionFTP.usuario = getFullRut('14119682-0');

    return this.http
      .post<any>(
        `${this.apiBff}/BffSitioPrivado/DownloadFTP/${getFullRut(
          '14119682-0'
        )}`,
        infoFTP,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error('Error al obtener los datos:', err.message);
          return of([]);
        }),
        map(data => {
          return data.base64;
        })
      );
  }

  getUltimoFechaHabil(): Observable<Date> {
    return of(moment().toDate());
  }

  public get screenSize$(): Observable<string> {
    return this._screenSize$;
  }

  public get screenDim$(): Observable<IScreenDim> {
    return this._screenDim$;
  }

  private _getScreenDim(): IScreenDim {
    return { width: window.innerWidth, height: window.innerHeight };
  }

  private _getScreenSize(): string {
    const [[newSize = 'never']] = Array.from(screenSizes.entries()).filter(
      ([size, mediaQuery]) => window.matchMedia(mediaQuery).matches
    );
    return newSize;
  }
}
